require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { Head } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

import { Toaster } from '@meforma/vue-toaster';
import { QuillEditor } from '@vueup/vue-quill';
import 'flowbite';



import '@vueup/vue-quill/dist/vue-quill.snow.css';

import VueCollapsiblePanel from '@dafcoe/vue-collapsible-panel';

import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css';

//Recipe Ingredient Component Added with calculation
import helpers from '@/Pages/VueClasses/RecipeIngredientsPrototype/helpers';
import conversions from '@/Pages/VueClasses/RecipeIngredientsPrototype/conversions';

import { Inertia } from '@inertiajs/inertia';

import { flare } from "@flareapp/js";
import { flareVue } from "@flareapp/vue";
// Initialization for ES Users
// alert('hello');
// alert(process.env.NODE_ENV);

const RecipeIngredientPrototype = (app, options = {}) => {
    //app.$helpers = helpers
    app.config.globalProperties.$helpers = helpers

    //app.$conversions = conversions
    app.config.globalProperties.$conversions = conversions
}

const el = document.getElementById('app');

window.Vapor = require('laravel-vapor');

import VueSplide from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';

if (process.env.NODE_ENV === 'production') {
    flare.light();
}


createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({ methods: { route } })
    .use(InertiaPlugin)

    .use(Toaster)
    .use(VueCollapsiblePanel)
    .use(VueSplide)
    .use(RecipeIngredientPrototype)
    .use(flareVue)
    .component('QuillEditor', QuillEditor)

    .mount(el);

InertiaProgress.init({ color: '#4B5563' });
Inertia.on('start', () => document.getElementById('full_loader').style.display = "flex");
Inertia.on('finish', () => document.getElementById('full_loader').style.display = "none");